import { currentUrlToParams } from '@/utils/common'
import { callApp } from '@/utils/wb-js-tookit/app-handle-tool'

const _wbAppBaseSchemeUrl = 'winbull://'
const _wbAppBaseUniversalLink = '?appLink='

class WbAppLink {
  static appLinks = [
    'article_details', // 文章/短文详情:
    'topic_detail', // 话题详情
    'community_income', // 社区收益页
    'announcement_detail', // 公告页
    'member_benefit', // 会员权益页
    'activity_center', // 活动页
    'login' // 登陆页
  ]

  static buildBaseAppLink(linkKey, params, buildType) {
    let link = linkKey
    if (params && params.id) {
      if (buildType === 'SchemeUrl') {
        link += `?id=${params.id}`
      }
      if (buildType === 'UniversalLink') {
        link += `&id=${params.id}`
      }
    }
    return link
  }

  // 生成SchemeUrl
  // winbull://article_details?id={id}
  static buildSchemeUrl(key, params) {
    let schemeUrl = _wbAppBaseSchemeUrl
    if (key && this.appLinks.includes(key)) {
      schemeUrl += this.buildBaseAppLink(key, params, 'SchemeUrl')
    }
    return schemeUrl
  }

  // 生成UniversalLink
  // ***/download.html?appLink=article_details&id={id}
  static buildUniversalLink(key, params) {
    let universalLink = _wbAppBaseUniversalLink
    if (key && this.appLinks.includes(key)) {
      universalLink += this.buildBaseAppLink(key, params, 'UniversalLink')
    } else {
      universalLink = ''
    }
    return universalLink
  }

  static tryCallApp() {
    const currentUrl = window.location.href
    let appLinkKey
    let urlParams
    if (currentUrl.includes(_wbAppBaseUniversalLink)) {
      urlParams = currentUrlToParams()
      appLinkKey = urlParams['appLink']
    }
    const schemeUrl = this.buildSchemeUrl(appLinkKey, urlParams)
    if (schemeUrl) {
      callApp(schemeUrl)
    }
  }
}

export default WbAppLink
